import React from 'react';

export function QuoteBlock({
  quote,
  author,
  className = '',
  ...props
}) {
  return (
    <blockquote className={`relative bg-surface border-l-4 border-accent pl-6 pr-4 py-6 my-8 rounded-xl shadow-md text-left ${className}`} {...props}>
      <p className="text-xl italic text-text-secondary mb-2">“{quote}”</p>
      {author && <footer className="text-accent font-semibold text-right">— {author}</footer>}
      <span className="absolute left-2 top-2 text-accent text-3xl select-none">“</span>
    </blockquote>
  );
}

export default QuoteBlock;
